import { useQuery } from 'react-query'
import client from './api-client';

const queryConfig = {
  staleTime: 1000 * 60 * 60,
  cacheTime: 1000 * 60 * 60,
}

async function fetchSoilTypes() {
  const data = await client(`soil-types/`)
  return data
}

export function useSoilTypes() {
  return useQuery(['soil-types'], () => fetchSoilTypes(), {
    refetchAllOnWindowFocus: false,
    ...queryConfig
  });
}
